import React, { useEffect, useState } from "react";

import ReactExport from "react-data-export";

import Btn from "../../components/buttons/Btn";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const ExportExcel = ({ valuesTable = [] }) => {
  const [dataExcel, setDataExcel] = useState([]);
  const [styleButton, setStyleButton] = useState({});

  useEffect(() => {
    setStyleButton({ display: "none" });

    const allColumns = [
      { name: "CNPJ/CPF", keys: ["empresa", "CNPJ"], alignment: "left" },
      {
        name: "Razão",
        keys: ["empresa", "Razao"],
        alignment: "left",
        width: 40,
      },

      {
        name: "Data",
        keys: ["mapa", "Data"],
        alignment: "center",
        width: 22,
      },
      {
        name: "Franquia CNPJ",
        keys: ["promocode", "IdPromotorFranquia"],
        alignment: "left",
      },
      {
        name: "Franquia Email",
        keys: ["promocode", "usuario", "Email"],
        alignment: "center",
        width: 30,
      },
      {
        name: "Tipo Cartão",
        keys: ["fenaconCliente", "TipoCartao"],
        alignment: "center",
      },
    ];

    const data = valuesTable.map((item) => {
      return allColumns.map((object) => {
        const value =
          object.keys.length === 2
            ? item[object.keys[0]]?.[object.keys[1]]
            : item[object.keys[0]]?.[object.keys[1]]?.[object.keys[2]];

        return value
          ? {
              value,
              style: {
                alignment: {
                  vertical: "center",
                  horizontal: object.alignment,
                },
              },
            }
          : { value: "" };
      });
    });

    const styleColumns = {
      font: { color: { rgb: "ffffff" }, bold: true },
      fill: { fgColor: { rgb: "212121" } },
      alignment: { vertical: "center", horizontal: "center" },
    };

    const columns = allColumns.map((object) => {
      return {
        title: object.name,
        width: { wch: object.width || 15 },
        style: styleColumns,
      };
    });

    setDataExcel([{ columns, data }]);
    setStyleButton({});
  }, [valuesTable]);

  return (
    <ExcelFile
      filename={`ResultadoEventos`}
      element={<Btn bg-color="green" style={styleButton} label="Exportar" />}
    >
      <ExcelSheet dataSet={dataExcel} name="ResultadoEventos"></ExcelSheet>
    </ExcelFile>
  );
};

export default ExportExcel;
